import { Injectable } from '@angular/core';
import { MenuItem } from '../../../core/interfaces/menu-item.interface';

@Injectable({
  providedIn: 'root'
})
export class SidenavMenuItemsService {

  private sidenavMenuItems: MenuItem[] = [];

  constructor() { }

  // Managers Menu Items.
  getManagersSidenavMenuItems(): MenuItem[] {
    const managersSidenavMenuItems: MenuItem[] = [
      {
        label: "Dashboard",
        route: "/dashboard",
        icon: "dashboard"
      },
      {
        label: "Download Resources",
        route: "/download-resources",
        icon: "download"
      },
      // {
      //   label: "Users",
      //   route: "#",
      //   icon: "people",
      //   isParent: true,
      //   children: [
      //     {
      //       label: "Create New Users",
      //       route: "/user/create-new-user",
      //       icon: "add_circle"
      //     },
      //     {
      //       label: "Manage Users",
      //       route: "/user/manage-user",
      //       icon: "settings"
      //     }
      //   ],
      //   expanded: true
      // }
    ];

    return managersSidenavMenuItems;
  }

  // Agents Menu Items.
  getAgentsSidenavMenuItems(): MenuItem[] {
    const agentsSidenavMenuItems: MenuItem[] = [
      {
        label: "Dashboard",
        route: "/dashboard",
        icon: "dashboard"
      },
      {
        label: "Download Resources",
        route: "/download-resources",
        icon: "download"
      }
    ];

    return agentsSidenavMenuItems;
  }

}
